import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import  MdOutlineDeleteOutline  from "../../Assests/delete-02-stroke-rounded.svg";
import { FaDoorOpen } from "react-icons/fa6";
import { MdOutlineAttachMoney } from "react-icons/md";
import { FaRegUserCircle } from "react-icons/fa";
import requestOrder from "../../Assests/time-quarter-pass-stroke-rounded (1).svg"
import view from "../../Assests/file-view-stroke-rounded.svg"
import { RxUpdate } from "react-icons/rx";
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { convertToCSV, download } from '../../lib/utils/export';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { numberOfData } from '../../lib/definitions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DropDown from '../GDropDownList/DropDown';
import toast from 'react-hot-toast';
import i18n from '../../lib/i18n';
import NotData from '../../ui/sharedUi/noData';
import { FaMapMarkedAlt } from "react-icons/fa";
import { FcApproval } from "react-icons/fc";
import { MdEdit } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import MapPopup from '../../lib/utils/GoogleMapPopup';
import { FcRating } from "react-icons/fc";
import { MdOutlineStarRate } from "react-icons/md";

const getNestedValue = (obj, path) => {
  return path?.split('.')?.reduce((acc, part) => acc && acc[part], obj);
};

const Table = ({ columns, rows, edit, openDeleteConfirmation, openConfirmation, openOrderDetails, action, confirmReport, loadingReport, name, showExportDialog, openCloseExportDialog, ExportTableWithPaginiation, rowsExportPaginiation }) => {

  const nav = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [lat, setLat] = useState(null);
  const [lan, setLan] = useState(null);
  const [exportValue, setExportValue] = useState(null);
  const t = i18n.t.bind(i18n);
  const currentLang = i18n.language;

  const onChangeExportValue = (e) => {
    setExportValue(e);
  };

  const getValue = (item, key) => item && item[key] !== undefined ? item[key] : "";

  useEffect (()=>{
    let keys = [];
    if(rowsExportPaginiation?.length > 1){
        keys = columns.map(col => col.key);
        const dataToExport = rowsExportPaginiation.map(item =>
            keys.reduce((acc, key) => {
            acc[key] = getValue(item, key);
            return acc;
            }, {})
        );
        const csv = convertToCSV(dataToExport, columns);
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
        const filename = `${name}-${timestamp}.csv`;
        download(filename, csv);
        setExportValue(null);
        openCloseExportDialog(false);
    };
  },[rowsExportPaginiation])

  const ExportCSV = () => {
      const keys = columns.map(col => col.key);
      const dataToExport = rows.map(item =>
          keys.reduce((acc, key) => {
          acc[key] = getValue(item, key);
          return acc;
          }, {})
      );
      const csv = convertToCSV(dataToExport, columns);
      const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
      const filename = `${name}-${timestamp}.csv`;
      download(filename, csv);
      setExportValue(null);
      openCloseExportDialog(false);
  };

  const handleExportValue = () => {
    if(exportValue){
      ExportTableWithPaginiation(exportValue);
    }
    else {
      toast.error("please select the number of records")
    }
  };

  const handleNavEdit = (id) => {
    nav(`${edit}/${id}`);
  };

  const handleDeleteRecode = (id) => {
    openDeleteConfirmation(id);
  };

  const handleConfirmRecord = (id) => {
    openConfirmation(id);
  };

  const handleCompleteReport = (id) => {
    confirmReport(id);
  };

  const handleOpenDetailsPop = (id) => {
    openOrderDetails(id);
  };

  const onClose = () => {
    openCloseExportDialog(false);
  };

  const onCloseMap = () => {
    setIsOpen(false);
  };

  const handleLatAndLng = (lat, lan) => {
    setLan(lan);
    setLat(lat);
    if(lan && lat){
      setIsOpen(true);
    }
  };

  if(rows.length < 1){
    return <NotData />
  }

  return (
    <div className="overflow-x-auto scrollable">
      {showExportDialog && 
        <div className='fixed inset-0 bg-black/60 flex items-center justify-center z-40'>
          <div>
              <div className="bg-thirdly text-center rounded-2xl shadow-lg w-full p-6 relative overflow-y-auto max-h-[86vh] scrollable">
                <button onClick={onClose} className="absolute top-3 left-4 text-gray-500 hover:text-red-500 text-xl">
                  ✕
                </button>
                <h1 className='text-white text-lg pt-6'>هذه العملية تمكنك من تصدير الجدول لملف CSV</h1>
                <p className='text-white text-md py-4 mb-4 text-center'>اختر شكل التصدير</p>
                <div className='flex justify-between items-center pb-2'>
                  <h1 className='text-white'>1-</h1>
                  <div className='w-52'>
                    <DropDown options={numberOfData} value={exportValue} onchange={onChangeExportValue} defaultText="اختر عدد النتائج " paramkey="per_page" />
                  </div>
                  <button onClick={handleExportValue}  className="px-5 py-2  rounded-md bg-secondary"> مع فهرسة </button>
                </div>
                <div className='border-b border-gray-500/40 w-[70%] m-auto text-center'><h1 className='relative top-3 text-sm text-white'>OR</h1></div>
                <div className='flex justify-start items-center mt-7'>
                  <h1 className='text-white'>2-</h1>
                  <button onClick={ExportCSV} className="px-4 py-2 mr-2 w-full text-center rounded-md bg-gray-400 "> بدون فهرسة </button>
                </div>
              </div>
          </div>
        </div>
      }
      { isOpen && <MapPopup lat={lat} lan={lan} isOpen={isOpen} onCloseMap={onCloseMap} /> }
    
      <table className="w-full bg-thirdly border-collapse rounded-lg shadow-md">
        <thead className="bg-furthly">
          <tr className="text-white text-center">
            {columns.map((column, index) => (
              <th
                key={index}
                className="px-4 py-4 font-semibold text-[15px]"
              >
                {column.header}
              </th>
            ))}
            <th className="px-4 py-4 font-semibold text-[15px]">
              {t("columns.options")}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="text-center transition"
            >
              {columns.map((column, colIndex) => {
                const value = getNestedValue(row, column.key);

                return (
                  <td
                      key={colIndex}
                      className={`px-4 py-3 ${
                        value === "PENDING" || value === "IN_PROGRESS"
                        ? "text-warning"
                        : value === "COMPLETED" || value === "DRIVER_ARRIVED"
                        ? "text-success"
                        : value === "CANCELLED"
                        ? "text-red-600"
                        : value === "ON_THE_WAY" || value === "GO_TO_STORE" || value === "AT_THE_STORE" || value === "DRIVER_ARRIVED"
                        ? "text-blue-600" :
                        (value == true && column.header != "المعرف" && column.header != "ID" && column.header != "Parent ID" && column.header != "معرف الأب" && column.header != "Price" && column.header != "السعر"  && column.header != "مكان الظهور" && column.header != "Position") 
                        ? "text-success" 
                        : (value == false && column.header != "المعرف" && column.header != "ID" && column.header != "Parent ID" && column.header != "معرف الأب" && column.header != "السعر" && column.header != "Price" && column.header != "مكان الظهور" && column.header != "Position") 
                        ? "text-red-600" 
                        : "text-white" } text-[15px] border-b border-gray-500/40`}
                    >
                      {(column.header === "الصورة" || column.header === "Photo") && (value != null) ? (
                        <img
                          className="w-12 h-11 m-auto rounded-md"
                          src={value}
                          alt="userPhoto"
                        />
                      ) : (column.header == t("columns.user_by_name")) ? <Link to={`/users/details/${row?.user_by?.id}`}>{value}</Link> 
                        : (column.header == t("columns.reported_user_name")) ? <Link to={`/users/details/${row?.reported_user?.id}`}>{value}</Link> 
                        : (column.header == t("columns.ad_name") && value ) ? <Link to={`/users/details/${row?.reported_user?.id}?id=${row?.reported_ad?.id}`}>{value}</Link>  
                        : (column.header == t("columns.full_name")) ? <Link to={`/users/details/${row?.user_id || row?.id}`}>{value}</Link>  
                        : (column.header === "الصورة"|| column.header === "Photo") && value == null ? (
                        <div className='flex justify-center items-center'>
                          <FaRegUserCircle className='text-[30px]'/>
                        </div>
                      ) : value == null ? (
                        "-"
                      ) : (column.header === "الحالة" || column.header === "Status") && value === true ? (
                        currentLang === "en" ? "active" : "فعال"
                      ) : (column.header === "الحالة" || column.header === "Status") && value === false ? (
                        currentLang === "en" ? "un active" : "غير فعال"
                      ) : column.key === "topResult" && value === false ? (
                        "غير فعال"
                      ) : column.key === "topResult" && value === true ? (
                        "فعال"
                      ) : column.key === "isHome" && value === false ? (
                        "لا يظهر"
                      ) : column.key === "accept" && value === true ? (
                        currentLang === "en" ? "accepted" : "مقبول"
                      ) : column.key === "accept" && value === false ? (
                        currentLang === "en" ? "not accepted" : " غير مقبول "
                      ) : column.key === "isHome" && value === true ? (
                        "يظهر"
                      ) : column.key === "confirmed" && value === false ? (
                        "غير موثق"
                      ) : column.key === "confirmed" && value === true ? (
                        "موثق"
                      ) : column.key === "position" && value == 1 ? (
                        "ظهور عادي"
                      ) : column.key === "duration" ? (
                        `${value} يوم`
                      ) : column.key === "position" && value == 2 ? (
                        "ظهور في الصفحة الرئيسية"
                      ) : column.key === "required" && value === true ? (
                        "اجباري"
                      ) : column.key === "required" && value === false ? (
                        "اختياري"
                      ) : typeof value === "object" ? (
                        value.ar || value.en || JSON.stringify(value)
                      ) : (
                        value
                      )}
                  </td>
                );
              })}
              <td className="px-4 py-3 h-full text-gray-800 border-b border-gray-500/40">
                <div className="flex flex-row justify-around gap-3">
                  {(openConfirmation && action =="confirm") &&
                    <img
                      src={requestOrder}
                      className="h-6 text-white cursor-pointer"
                      // onClick={handleExportCurrentView}
                      onClick={() => handleConfirmRecord(row.id)}
                    />
                  }
                  {( action =="detailsAds") &&
                  (<>
                    <img
                      src={view}
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleOpenDetailsPop(row.id)}
                    />
                    <img
                      src={MdOutlineDeleteOutline}
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleDeleteRecode(row.id)}
                    />
                  </>)
                  }
                  {action =="confirm" &&
                    <img
                      src={view}
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleOpenDetailsPop(row.id) }
                    />
                  }
                  {action =="payment" &&
                    <RxUpdate
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleConfirmRecord(row.id)}
                    />
                  }
                  {action == "stores" &&
                    (<MdOutlineStarRate
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleOpenDetailsPop(row.id)}
                    />)
                  }
                  {action == "map" &&
                    (<MdOutlineStarRate
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleOpenDetailsPop(row.id)}
                    />)
                  }
                  {action == "map" &&
                    (<FaMapMarkedAlt
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleLatAndLng(row.latitude, row.longitude)}
                    />)
                  }
                  {action == "map" &&
                    (<MdOutlineAttachMoney
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleNavEdit(`transactions/${row.id}`)}
                    />)
                  }
                  {(action =="accept" ) &&
                    <FaEye
                      className="h-6 w-5 text-white cursor-pointer"
                      onClick={() => handleOpenDetailsPop(row.id)}
                    />
                  }
                  {action =="reports" && 
                  ( !loadingReport
                    ? <ChangeCircleIcon onClick={() => handleCompleteReport(row.id)} className='text-success cursor-pointer' />
                    : <HourglassBottomIcon
                        className="h-5 text-gray cursor-pointer"
                      />
                  )
                  }
                  {action =="user" && 
                    <img
                      src={MdOutlineDeleteOutline}
                        className="h-5 text-white cursor-pointer"
                        onClick={() => handleDeleteRecode(row.id)}
                    />
                  }
                  {edit === "/roles/edit" ? (
                    <FaDoorOpen
                      className="text-[18px] text-white cursor-pointer"
                      onClick={() => handleNavEdit(`${row.id}/permissions`)}
                    />
                  ) : null}
                  {(action != "confirm" && action != "detailsAds" && action != "payment" && action != "reports" && action != "user") &&
                    <>
                      <MdEdit
                        className="text-[20px] text-white cursor-pointer"
                        onClick={() => handleNavEdit(row.id)}
                      />
                    <img
                      src={MdOutlineDeleteOutline}
                        className="h-5 text-white cursor-pointer"
                        onClick={() => handleDeleteRecode(row.id)}
                      />
                    </>
                  }
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
